

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import VueScroller from 'vue-scroller'
Vue.use(VueScroller);


import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
template: '<App/>',
components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js